import type { Schema } from '@biteinc/common';

export const createOrgSchema: Schema.Model = {
  displayName: 'org',
  type: 'object',
  fields: {
    name: {
      type: 'keyString',
      required: true,
    },
    sourceOrgId: {
      type: 'mongoId',
      displayName: 'Clone From Org',
      biteOnly: true,
      tooltip: {
        text: 'Optional. If selected, the new org will be created with the selected org’s configuration as a starting point (settings, appearance, etc.).',
      },
      ui: 'dropdown',
    },
  },
};
